// extracted by mini-css-extract-plugin
module.exports = {"item":"SuggestionItem__item--1FP","btn":"SuggestionItem__btn--3V6","active":"SuggestionItem__active--RBP"};